module.exports = __webpack_public_path__ + "img/stopWatch.4036daba.svg";